import { useEffect, useLayoutEffect } from 'react';
var useIsomorphicLayoutEffect = typeof document !== 'undefined' ? useLayoutEffect : useEffect;
export default useIsomorphicLayoutEffect;
